import {Chip, Stack, styled, Typography} from '@mui/material';
import {isNil, isDate, get, find, toString} from 'lodash';
import {FC} from 'react';
import {useGetDictsServiceTypesMyQuery} from '../../../../global/services/service-types';
import {
  CONTRACT_TABLE_FILTERS_CRITERIA_KEYS,
  CONTRACT_TABLE_FILTERS_CRITERIA_VALUES,
  CONTRACT_TABLE_FILTERS_STATUSES_MAP,
} from '../../constants/contract-table-filters.constants';
import {isFilterStatus} from '../../helpers/is-filter-status.helper';
import {Filter} from '../../types';

interface Props {
  filters: Filter[];
  onDelete?: (index: number) => void;
}

export const ContractsTableFiltersList: FC<Props> = ({onDelete, filters}) => {
  const {data = []} = useGetDictsServiceTypesMyQuery({});

  const prepareFilterValue = ({value, key}: Filter): string => {
    if (isNil(value)) return '';
    if (isDate(value)) return value.toLocaleDateString();
    if (isFilterStatus(value)) return get(CONTRACT_TABLE_FILTERS_STATUSES_MAP, value, '');
    if (key === CONTRACT_TABLE_FILTERS_CRITERIA_KEYS.serviceType) return get(find(data, {code: value}), 'name', '');
    return toString(value);
  };

  return (
    <Container>
      {filters.map((filter, i) => (
        <StyledChip
          key={filter.key}
          variant="outlined"
          label={
            <Stack direction="row" spacing={0.5}>
              <Typography variant="subtitle2" color="#818181">
                {get(CONTRACT_TABLE_FILTERS_CRITERIA_VALUES, filter.key)}:
              </Typography>
              <Typography variant="subtitle2">{prepareFilterValue(filter)}</Typography>
            </Stack>
          }
          {...(onDelete && {onDelete: () => onDelete(i)})}
        />
      ))}
    </Container>
  );
};

const StyledChip = styled(Chip)({
  backgroundColor: '#FFECCC',
  border: `1px solid #FF9F00`,
  '& .MuiChip-deleteIcon': {
    color: '#2196f3',
  },
  '& .MuiChip-deleteIcon:hover': {
    color: '#03a9f4',
  },
});

const Container = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  gap: 8,
  width: '100%',
});
